import React, { useCallback, useEffect, useState } from "react";

import { connect } from "react-redux";
import { addDataToMap, forwardTo } from "kepler.gl/actions";
import { Box, Button, Card, CardContent, Container } from "@mui/material";
import Kepler from "components/kleperMap/Kepler.component";
import { updateMap } from "kepler.gl/actions";
import {
  getPointCO2Heatmap,
  getPointPM10Heatmap,
  getPointPM2_5Heatmap,
} from "keplerConfigs/config/environmentMapConfig/pointsConfig";
import {
  getHeatmapCO2Norm,
  getHeatmapPM10Norm,
  getHeatmapPM2_5Norm,
} from "keplerConfigs/config/environmentMapConfig/heatmapsConfig";
import { getTimeZoneStandard } from "utils/timezone";
import { mapStyleConfig } from "keplerConfigs/config/mapStyleConfig";
import { mapStateConfig } from "keplerConfigs/config/mapStateConfig";
import { useTranslation } from "react-i18next";
import { getPointConfigPCountHeatmap } from "keplerConfigs/config/environmentMapConfig/pointsConf/pcount";
import { getPointConfigRainfallHeatmap } from "keplerConfigs/config/environmentMapConfig/pointsConf/rain";
import { getPointConfigWindSpeedHeatmap } from "keplerConfigs/config/environmentMapConfig/pointsConf/wind";
import { getPointConfigBarPressHeatmap } from "keplerConfigs/config/environmentMapConfig/pointsConf/barPress";
import { getPointConfigUmidityHeatmap } from "keplerConfigs/config/environmentMapConfig/pointsConf/umidity";
import { getPointConfigTempHeatmap } from "keplerConfigs/config/environmentMapConfig/pointsConf/airTemp";
import { getPointConfigLuxHeatmap } from "keplerConfigs/config/environmentMapConfig/pointsConf/lux";
import {
  getHeatmapRainfallNorm,
} from "keplerConfigs/config/environmentMapConfig/heatmapConf/rain";
import { getHeatmapConfigTempNorm } from "keplerConfigs/config/environmentMapConfig/heatmapConf/airTemp";
import { getHeatmapConfigLuxNorm } from "keplerConfigs/config/environmentMapConfig/heatmapConf/lux";
import { getHeatmapConfigHumidityNorm } from "keplerConfigs/config/environmentMapConfig/heatmapConf/umidity";
import { getHeatmapConfigBarPressNorm } from "keplerConfigs/config/environmentMapConfig/heatmapConf/barPress";
import { getHeatmapPCountNorm } from "keplerConfigs/config/environmentMapConfig/heatmapConf/pcount";
import { getHeatmapWindSpeedNorm } from "keplerConfigs/config/environmentMapConfig/heatmapConf/wind";
import FiltersAccordionComponent from "components/filtersMap/FiltersAccordion.component";

const FiltersKeplerMapContainer = ({
  zoom = 12,
  config,
  height,
  selected,
  options,
  checked,
  onChange,
  ...props
}) => {
  const { t, i18n } = useTranslation();
  const [valuesConfig, setValuesConfig] = useState(null);
  const [viewButtonShow, setViewButtonShow] = useState(true);

  const createInteractionConfig = useCallback(() => {
    const obj = {};
    const configKeys = [
      { key: "tdm_temp", name: "temperature" },
      { key: "CO2", name: "CO2" },
      { key: "lux", name: "illuminance" },
      { key: "humidity", name: "humidity" },
      { key: "bar_press", name: "atmospheric-pressure" },
      { key: "rain_intensity", name: "Rainfall intensity" },
      { key: "pm10", name: "PM10" },
      { key: "pm2_5", name: "PM2.5" },
      { key: "wind-speed", name: "wind-speed" },
      { key: "pcount", name: "People" },
    ];

    configKeys.map((item) => {
      obj[`${item.key}`] = [
        {
          name: "ID",
          format: null,
        },
        {
          name: "Cluster",
          format: null,
        },
        {
          name: t("Address"),
          format: null,
        },
        {
          name: t(item.name),
          format: null,
        },
        {
          name: t("Time"),
          format: null,
        },
      ];

      return obj;
    });

    let configInteraction = {
      tooltip: {
        fieldsToShow: obj,
        compareMode: false,
        compareType: "absolute",
        enabled: true,
      },
      brush: {
        size: 0.5,
        enabled: false,
      },
      geocoder: {
        enabled: false,
      },
      coordinate: {
        enabled: false,
      },
    };

    return configInteraction;
  }, [t]);

  const loadDataOnMap = (values) => {
    props.dispatch(addDataToMap(values));
    props.keplerGlDispatch(updateMap({ zoom: zoom }));
    setValuesConfig(values);
    setViewButtonShow(true);
  };

  const addAnimation = useCallback(() => {
    const rows = valuesConfig?.datasets?.data?.rows;
    const start = rows && new Date(getTimeZoneStandard(rows[2][7]));
    const end = rows && new Date(getTimeZoneStandard(rows[rows.length - 1][7]));

    if (start?.getTime() && end?.getTime() && valuesConfig?.datasets?.data.id) {
      props.keplerGlDispatch(
        addDataToMap({
          options: valuesConfig.options,
          datasets: valuesConfig.datasets,

          config: {
            visState: {
              filters:
                start && end
                  ? [
                      {
                        dataId: [valuesConfig.datasets.data.id],
                        id: "kyq8rehga",
                        name: [t("Time")],
                        type: "timeRange",
                        value: [start.getTime(), start.getTime() + ((end.getTime() - start.getTime()) / 12)],
                        enlarged: true,
                        plotType: "histogram",
                        animationWindow: "free",
                        yAxis: null,
                        speed: 1,
                        defaultTimeFormat:
                          i18n?.language === "en" ? "hh" : "HH",
                        timeFormat:
                          i18n?.language === "en"
                            ? `yyyy/MM/DD HH:mm:ss`
                            : `DD/MM/yyyy HH:mm:ss`,
                      },
                    ]
                  : [],
              layers: [
                getPointCO2Heatmap(0),
                getHeatmapCO2Norm(10),

                getPointConfigUmidityHeatmap(t("humidity"), 0),
                getHeatmapConfigHumidityNorm(t("humidity"), 10),

                getPointConfigTempHeatmap(t("temperature"), 0),
                getHeatmapConfigTempNorm(t("temperature"), 10),

                getPointConfigLuxHeatmap(t("illuminance"), 0),
                getHeatmapConfigLuxNorm(10),

                getPointConfigBarPressHeatmap(t("atmospheric-pressure"), 0),
                getHeatmapConfigBarPressNorm(t("atmospheric-pressure"), 10),

                getHeatmapPM10Norm(10),
                getPointPM10Heatmap(0),

                getPointPM2_5Heatmap(0),
                getHeatmapPM2_5Norm(10),

                getPointConfigRainfallHeatmap(t("rainfall-intensity"), 0),
                getHeatmapRainfallNorm(t("Rainfall intensity"), 10),

                getPointConfigWindSpeedHeatmap(t("wind-speed"), 0),
                getHeatmapWindSpeedNorm(t("wind-speed"), 10),

                getPointConfigPCountHeatmap(t("people-counter"), 0),
                getHeatmapPCountNorm(t("People"), 10),
              ],

              interactionConfig: createInteractionConfig(),
              layerBlending: valuesConfig.layerBlending,
              animationConfig: valuesConfig.animationConfig,
            },
            mapState: mapStateConfig,
            mapStyle: mapStyleConfig,
          },
        })
      );
      setViewButtonShow(false);
    }
    // eslint-disable-next-line
  }, [valuesConfig, props, t, i18n]);

  useEffect(() => {
    loadDataOnMap(config);

    // eslint-disable-next-line
  }, [config]);

  return (
    <Box sx={{ position: "relative" }}>
      <Box>
        <Card
          sx={{
            border: "1px solid #E6DEB8",
            boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
          }}
        >
          <CardContent sx={{ "&.MuiCardContent-root": { padding: 0.5 } }}>
            <Card sx={{ padding: 0 }}>
              <Box sx={{ position: "relative" }}>
                {viewButtonShow && (
                  <Box
                    sx={{ position: "absolute", top: 10, left: 10, zIndex: 20 }}
                  >
                    <Button
                      onClick={() => addAnimation()}
                      color="primary"
                      variant="contained"
                    >
                      {t("show animation")}
                    </Button>
                  </Box>
                )}
                <Container
                  maxWidth={false}
                  style={{ padding: 0, maxHeight: height }}
                >
                  <Kepler {...props} height={height} />
                </Container>
              </Box>
            </Card>
          </CardContent>
        </Card>
      </Box>

      <Box sx={{ position: "absolute", top: 15, right: 15 }}>
        <FiltersAccordionComponent
          selected={selected}
          options={options}
          checked={checked}
          onChange={onChange}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => state;
const dispatchToProps = (dispatch) => ({
  dispatch,
  keplerGlDispatch: forwardTo("map", dispatch),
});

export default connect(
  mapStateToProps,
  dispatchToProps
)(FiltersKeplerMapContainer);
